import { Injectable } from "@angular/core";
import { NotifierService } from "angular-notifier";

@Injectable()
export class NotificationService  {
    constructor(private notifierService: NotifierService){ }

    showSuccess(message: string){
        this.notifierService.show({
            type: 'success',
            message: message,
        });
    }

    showError(message: string) {
        this.notifierService.show({
            type: 'error',
            message: message,
        });
    }
}